import React, { useEffect, useState } from "react";
import { ModalFooter } from "@atlaskit/modal-dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  setWizardPage,
  setWizardErrorMsg,
  setWizard,
  clearWizard
} from "../../redux/actions/wizardActions";
import {
clearAsset
} from "../../redux/actions/jiraAssetsActions";
import Button from "@atlaskit/button/standard-button";
import { getCurrentWizardValidateFunction } from "../tutorials/wizardRegistry";

const WizardModalFooter = () => {
  const currentPage = useSelector((state) => state.wizard.currentPage);
  const currentWizard = useSelector((state) => state.wizard.currentWizard);

  //forvalidation---
  const objectTypeName = useSelector((state) => state.jiraAssets.objectTypeName);
  const selectedAssetSchema = useSelector((state) => state.jiraAssets.selectedAssetSchema);
  const importSourceName = useSelector((state) => state.jiraAssets.importSourceName);
  const currentData = useSelector((state) => state.wizard.currentData);
  const creds = useSelector((state) => state.auth.creds);
  //----

  const [btText, setBtText] = useState("Next");

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentPage && currentWizard) {
      if (currentPage === currentWizard.pages.length - 1) {
        setBtText("Create");
      } else if (currentPage === currentWizard.pages.length) {
        setBtText("Close");

      } else {
        setBtText("Next");
      }
    }
  }, [currentWizard, currentPage]);
  const onClickNext = async () => {
    dispatch(setWizardErrorMsg(""));

    //exit last page
    if(currentPage === currentWizard.pages.length){
      dispatch(clearWizard());
      dispatch(clearAsset());
    }

    const validate = getCurrentWizardValidateFunction(
      currentWizard.id,
      currentPage
    );
    const validation = await validate(currentData,{objectTypeName:objectTypeName,selectedAssetSchema:selectedAssetSchema,importSourceName:importSourceName},creds);
    //console.log(validation.valid);
    if (validation.valid) {
      dispatch(setWizardPage(currentPage + 1));
      dispatch(setWizard(currentWizard));
    } else {
      dispatch(setWizardErrorMsg(validation.message));
    }
  };

  return (
    <ModalFooter>
      <div></div>
      {currentPage > 0 && (
        <Button appearance="primary" onClick={onClickNext}>
          {btText}
        </Button>
      )}
    </ModalFooter>
  );
};
export default WizardModalFooter;
